import React, { Fragment } from "react";
import SEO from "../../components/SEO/SEO";
import Header from "../../components/Header/Header";
import PageTitle from "../../components/pagetitle/PageTitle";
import BlogList from "../../components/BlogList/BlogList";
import Footer from "../../components/footer/Footer";
import Scrollbar from "../../components/scrollbar/scrollbar";

const BlogPage: React.FC = () => {
  return (
    <Fragment>
      <SEO title="Blog" description="Latest news, updates, and insights from the AXOIX team on AI-powered business management." path="/blog" />
      <div className="blog-page inner-page">
        <div className="body_wrap o-clip">
          <Header />
          <main>
            <PageTitle pageTitle="AXOIX Blog" pagesub="Blog" />
            <BlogList />
          </main>
          <Footer />
          <Scrollbar />
        </div>
      </div>
    </Fragment>
  );
};

export default BlogPage;
